<template>
  <v-container><question-controller></question-controller></v-container>
</template>
<script>
  import QuestionController from '@/components/QuestionController';

  export default {
    name: 'survey',
    components: { QuestionController },
  };
</script>
